import { CustomSelectFieldProps, SelectField } from 'components/form'
import { TipoVisibilidadePoligonoTerritorio } from 'graphql/types.generated'

type VisibilidadePoligonoTerritorioSelectFieldProps = CustomSelectFieldProps<TipoVisibilidadePoligonoTerritorio>

export const TIPO_VISIBILIDADE_POLIGONO_TERRITORIO_RECORD: Record<TipoVisibilidadePoligonoTerritorio, string> = {
  TODOS: 'Todos do município',
  UNIDADE_SAUDE: 'Somente minha unidade de saúde',
  EQUIPE: 'Somente minha equipe',
  AUTOR: 'Somente eu',
}

export function VisibilidadePoligonoTerritorioSelectField(props: VisibilidadePoligonoTerritorioSelectFieldProps) {
  return <SelectField<TipoVisibilidadePoligonoTerritorio> items={items} itemToString={itemToString} {...props} />
}

const items = Object.keys(TIPO_VISIBILIDADE_POLIGONO_TERRITORIO_RECORD) as TipoVisibilidadePoligonoTerritorio[]

const itemToString = (item: TipoVisibilidadePoligonoTerritorio | null): string | null => {
  return item ? TIPO_VISIBILIDADE_POLIGONO_TERRITORIO_RECORD[item] : null
}
